import { render, staticRenderFns } from "./DueDateSelector.vue?vue&type=template&id=3da32085"
import script from "./DueDateSelector.vue?vue&type=script&lang=js"
export * from "./DueDateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports